module.exports = __webpack_public_path__ + "static/media/reception3.3a5f1e5c.jpg";